import styled from "@emotion/styled";
import React, { Fragment } from "react";

import type { INavGroup, INavMenu } from "../../types";

import ItemButton from "./ItemButton";
import ItemLink from "./ItemLink";
import NavGroup from "./NavGroup";

import { PageList } from ".";

const Spacer = styled.hr(({ theme }) => ({
  // important needed here due to a conflicting style in global.css
  height: `${theme.spacing.SML.sml}px !important`,
  background: theme.colors.background.secondary,
  border: 0,
  borderBottom: `1px solid ${theme.colors.border.default}`,
  margin: 0,
}));

interface Props {
  data: INavMenu;
  onPageChange: (page: INavGroup) => void;
}

export default function NavMenu({ data, onPageChange }: Props) {
  return (
    <PageList>
      {(data.submenu || []).map((group) => {
        if (group.hideOnMobile) {
          return null;
        }
        if (group.title.link && group.title.linkOnlyOnMobile) {
          return (
            <Fragment key={group._key}>
              <li>
                <ItemLink
                  to={
                    group.title.link.link.to ||
                    group.title.link.link.toExternal ||
                    group.title.link.link.hash ||
                    "#"
                  }
                  noFollow={group.title.link.link.noFollow}
                >
                  {group.title.text}
                </ItemLink>
              </li>
              {group.addSpacerAfterOnMobile && (
                <li>
                  <Spacer />
                </li>
              )}
            </Fragment>
          );
        }
        if (group.collapseOnMobile) {
          return (
            <Fragment key={group._key}>
              <li>
                <ItemButton
                  title={group.title.text}
                  onClick={() => onPageChange(group)}
                />
              </li>
              {group.addSpacerAfterOnMobile && (
                <li>
                  <Spacer />
                </li>
              )}
            </Fragment>
          );
        }
        return (
          <Fragment key={group._key}>
            <li>
              <NavGroup data={group} />
            </li>
            {group.addSpacerAfterOnMobile && (
              <li>
                <Spacer />
              </li>
            )}
          </Fragment>
        );
      })}
    </PageList>
  );
}
